import { callApi } from '@/api/api-core'
import moment from 'moment-timezone'

export const fetchInfo = function(ownerHandlesFailure) {
	return callApi(
		'POST',
		'v12/products/fixedpriceticket/info',
		{
			salesChannelIdentifier: 'Webshop'
		},
		ownerHandlesFailure
	)
}

export const createOrder = function(passengers, productVariantId, validFromInstant, ownerHandlesFailure) {
	if (!moment.isMoment(validFromInstant)) {
		throw new Error('validFromInstant is not a moment')
	}

	const requestData = {
		salesChannelIdentifier: 'Webshop',
		passengers,
		validFromInstant,
		productVariantId
	}

	return callApi('POST', 'v2/products/fixedpriceticket/order', requestData, ownerHandlesFailure)
}
